export enum FieldType {
  All = 'Tous',
  Formation = 'Formation',
  Education = 'Éducation',
  Public = 'Public',
  Pharmaceutical = 'Pharmaceutique',
  RealEstate = 'Immobilier',
  Ecommerce = 'E-commerce',
}
